import Headroom from 'headroom.js'
import Rellax from 'rellax'
import 'slick-carousel'

const initHeader = () => {
  const headroom = new Headroom(document.querySelector('header'), {
    tolerance: 10,
  })
  headroom.init()
  $(document).on('click', '[data-toggle-nav]', () => {
    $('.menu-btn').toggleClass('active')
    $('.mobile').toggleClass('nav-active')
    $('body').toggleClass('no-scroll')
  })
}

//smooth scroll
$(function() {
  $('a[href*="#"]:not([href="#"])').click(function() {
    if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
      var target = $(this.hash);
      target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
      if (target.length) {
        $('html, body').animate({
          scrollTop: target.offset().top,
        }, 1000);
        return false;
      }
    }
  });
});


/** 
 * Add parallax functionality to decorations
 * @param {string} selector
 */
const initRellax = (selector) => {
  let decoration = document.querySelector(selector)
  if (decoration) {
    new Rellax(selector)
  }
}

// Slider functionality
const initSlider = () => {
  $('.slider').slick({
    arrows: true,
    nextArrow: '<button type="button" class="slick-next"><i class="fa-regular fa-arrow-right c(dull-teal)" aria-label="Next Slide"></i></button>',
    prevArrow: '<button type="button" class="slick-prev"><i class="fa-regular fa-arrow-left c(dull-teal)" aria-label="Previous Slide"></i></button>',
    appendArrows: '.arrow-container',
    dots: false,
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
  })
}

export default {
  init() {
    // JavaScript to be fired on all pages
  },
  finalize() {
    initHeader()
    initRellax('.parallax')
    initSlider()
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js